import { Button, Form, UploadFile } from 'antd';
import { useCallback } from 'react';
import { moneyToNumber } from '../../shared/antd/components/MoneyInput';
import { PaymentFormProps } from './payment-form.props';
import { PaymentAmountInput } from './PaymentAmountInput';
import { PaymentCommentInput } from './PaymentCommentInput';
import { PaymentType } from './payments.model';
import { ReceiptUpload, getFilesFromUploads } from './ReceiptUpload';
import { MakePaymentArgs } from './thunk/makePayment';
import { useAppDispatch } from '../../app/hooks';
import { setOrderProcessing } from './Checkout.slice';

type CashPaymentFormState = {
    amount: string;
    comment: string;
    receipts: UploadFile[];
};

export type CashPaymentProps = PaymentFormProps;
export const CashPaymentForm = ({ onCancel, onFinish, amountDue, processing }: CashPaymentProps): JSX.Element => {
    const dispatch = useAppDispatch();
    const [form] = Form.useForm<CashPaymentFormState>();

    const submitPayment = useCallback(
        async (formData: CashPaymentFormState) => {
            dispatch(setOrderProcessing(true));

            const payload = {
                amount: moneyToNumber(formData.amount),
                comment: formData.comment ?? '',
                paymentType: PaymentType.Cash,
                attachments: getFilesFromUploads(formData.receipts),
            } as MakePaymentArgs;

            onFinish(payload);
        },
        [dispatch, onFinish],
    );

    return (
        <Form
            form={form}
            labelAlign='left'
            layout='vertical'
            requiredMark={true}
            onFinish={submitPayment}
            colon={false}>
            <ReceiptUpload />
            <PaymentAmountInput defaultValue={amountDue} />
            <PaymentCommentInput />

            <Button type='primary' htmlType='submit' loading={processing} disabled={processing}>
                Confirm Order
            </Button>
        </Form>
    );
};
